<ng-template #itemTemplate let-item>
    <!-- fractional spacing for responsiveness -->
    @if (!noUnitInProduct()) {
        <div
            class="grid grid-cols-[2.5fr_4.5fr_4.0fr] items-center w-full min-w-0 group"
            (mousemove)="onItemMouseMove(item, $event)"
            (mouseup)="onItemMouseUp(item, $event)"
            (click)="onRowClick(item, $event)"
        >
            <div class="pr-3 break-words whitespace-normal min-w-0">
                <div class="flex flex-col">
                    <span>
                        {{ item.unit?.identifier }}
                        @if (roundedQuantityTooltip(item); as roundedTooltip) {
                            <i
                                class="fas fa-exclamation-triangle text-amber-500 dark:text-amber-400 ms-1"
                                [pTooltip]="roundedTooltip"
                                tooltipPosition="top"
                                appendTo="body"
                                aria-hidden="true"
                            ></i>
                        }
                        @if (!item.allowFractions) {
                            <i
                                class="fa-solid fa-arrow-circle-up me-1"
                                [pTooltip]="noFractionsTooltip()"
                                aria-hidden="true"
                            ></i>
                        }
                    </span>
                    @if (item.scanId) {
                        <span class="text-slate-400">{{ item.scanId }}</span>
                    }
                </div>
            </div>
            <!-- button with only outlined and green tick icon -->
            <div ng class="px-4 border-r border-gray-600 flex justify-end items-center min-w-0">
                <app-phx-input-number
                    [displayValue]="item.displayQuantity ?? item.quantity"
                    [dataTestId]="'unit-conv-' + item.unit?.identifier"
                    (displayValueChange)="onQuantityChange(item, $event)"
                    (click)="onItemClick(item, $event)"
                    (mousedown)="onInputMouseDown(item, $event)"
                    (mousemove)="onInputMouseMove($event)"
                    (mouseup)="onInputMouseUp($event)"
                    (keydown)="onKeyDown(item, $event)"
                    [pAutoFocus]="isItemFocused(item)"
                    [selectAllOnFirstFocus]="isItemFocused(item)"
                    [minFractionDigits]="getFractionDigitsForItem(item)"
                    [maxFractionDigits]="getFractionDigitsForItem(item)"
                    [step]="item.unit?.quantityStep"
                    (onEndInputGroupAddonClick)="onCheckClick(item, $event)"
                >
                    <ng-template #endInputGroupAddonContent>
                        <!-- style class that on hover of parent element sets text-green-200  -->
                        <i class="fa-solid fa-check text-green-500 group-hover:text-green-300"></i>
                    </ng-template>
                </app-phx-input-number>
            </div>
            <span class="pl-3 break-words whitespace-normal min-w-0 flex flex-col">
                @if (item.conversionRate && item.sourceUnit) {
                    <span class="text-slate-400">
                        {{ '1 ' + item.unit?.identifier }} =
                        {{ formatConversionRate(item.conversionRate) }}
                        {{ item.sourceUnit.identifier }}
                    </span>
                }
                @if (baseUnitMismatchLabel(item); as correctConversion) {
                    <span class="flex items-center gap-2 min-w-0">
                        <span
                            class="text-amber-500 dark:text-amber-400 cursor-pointer"
                            (mousedown)="$event.stopPropagation()"
                            (click)="onApplyQuantityToOtherColumns(item, $event)"
                            >{{ correctConversion }}</span
                        >
                        <button
                            type="button"
                            class="inline-flex items-center justify-center shrink-0 text-green-500 hover:text-green-300"
                            (mousedown)="$event.stopPropagation()"
                            (click)="onApplyQuantityToOtherColumns(item, $event)"
                        >
                            <i class="fa-solid fa-check" aria-hidden="true"></i>
                        </button>
                    </span>
                }
            </span>
        </div>
    } @else {
        <span>{{ item.unit?.identifier }}</span>
    }
</ng-template>

<ng-template #selectedItemTemplate let-item>
    {{ documentLineItem()?.unitShortForm ?? item.unit?.shortForm ?? item.unit?.identifier }}
    <span *ngIf="this.items()?.length > 1 && !noUnitInProduct()">*</span>
</ng-template>

<ng-template #footerTemplate let-item>
    @if (activeUnitConversionsWithSourceUnit()) {
        <div class="flex justify-left pb-2 pl-3">
            <phx-checkbox [ngModel]="forceBaseUnitSettingSig()" (inlineChange)="forceBaseUnitSettingSig.set($event)">
                {{ 'entities.DocumentLineItem.unitConversion.forceBaseUnit' | translate }}
            </phx-checkbox>
        </div>
    }
</ng-template>
